const config = {
  env: "local",
  // apiUrl: "http://localhost:8080/admin/",
  apiUrl: "https://api.iconglobalmachinery.com/admin",
};

export default config;
